import * as React from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';
import mergeClasses from 'shared/lib/utils';
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from 'shared/ui/form';
import { Textarea } from 'shared/ui/textarea';
interface FormControlInputProps<TData extends FieldValues> extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: Path<TData>;
  control: Control<TData> | undefined;
  description?: string | React.ReactNode;
}
const FormControlTextarea = <TData extends FieldValues,>({
  name,
  control,
  className,
  description,
  ...props
}: FormControlInputProps<TData>) => {
  return <FormField name={name} control={control} render={({
    field
  }) => <FormItem>
          <FormControl>
            <Textarea {...field} {...props} className={mergeClasses('w-full h-24 border rounded-md p-2', className)} />
          </FormControl>
          <FormDescription>{description}</FormDescription>
          <FormMessage />
        </FormItem>} data-sentry-element="FormField" data-sentry-component="FormControlTextarea" data-sentry-source-file="form-textarea.tsx" />;
};
export { FormControlTextarea };